
import React from "react";
import { Button } from "@/components/ui/button";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/components/auth/AuthProvider";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { User, LogOut, ClipboardList, Settings } from "lucide-react";

export function AuthButtons() {
  const { user, signOut } = useAuth();
  const location = useLocation();

  // Don't show sign in button on sign in page
  if (location.pathname.includes("/auth")) {
    return null;
  }
  
  return (
    <div className="flex items-center gap-3">
      {user ? (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" className="flex items-center gap-2">
              <User size={14} />
              <span className="max-md:sr-only">
                {user.user_metadata?.first_name || 'Account'}
              </span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem asChild>
              <Link to="/dashboard" className="cursor-pointer flex items-center gap-2">
                <ClipboardList className="h-4 w-4" />
                <span>Dashboard</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/settings" className="cursor-pointer flex items-center gap-2">
                <Settings className="h-4 w-4" />
                <span>Settings</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={signOut} className="cursor-pointer flex items-center gap-2">
              <LogOut className="h-4 w-4" />
              <span>Sign out</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      ) : (
        <>
          <Button asChild variant="ghost" className="hidden md:flex hover:text-grandpal-green-dark">
            <Link to="/auth/login">Sign In</Link>
          </Button>
          <Button asChild className="bg-grandpal-green-dark hover:bg-grandpal-green-darkHover text-white">
            <Link to="/auth/signup">Sign up for Free</Link>
          </Button>
        </>
      )}
    </div>
  );
}
